/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
  {
    url: "/Overview",
    name: "Overview",
    slug: "Overview",
    icon: "HomeIcon",
     moduleId: 1
  },
    {
    url: "/patientDetailsDashboard",
    name: "Patients",
    slug: "patientDashboard",
    icon: "FileTextIcon",
      moduleId: 2
  },

  {
    url: "/OpDashboardView",
    name: "OP ",
    slug: "opDashboard",
    icon: "ClipboardIcon",
      moduleId: 3
  },
    {
    url: "/IpDashboardView",
    name: "IP",
    slug: "ipDashboard",
    icon: "ClipboardIcon",
      moduleId: 4
  },
 
  {
  url: "/billingDashboard",   
  name: "Billing",           
  slug: "billingDashboard",   
  icon: "CreditCardIcon", 
    moduleId: 5   
},

{
  url: "/paymentCollection",           // This is the route path
  name: "Receipt",          // Label on sidebar
  slug: "paymentCollection",           // Unique key
  icon: "DollarSignIcon",  
    moduleId: 6            // Feather icon (💡 you can change it)
},
  //  {
  //   url: "/tokenBookingDashboard",
  //   name: "Token Dashboard",
  //   slug: "tokenDashboard",
  //   icon: "UsersIcon",
  // },


  {
    url: "/tokenBookingDashboardView",
    name: "Token ",
    slug: "tokenDashboard",
    icon: "UsersIcon",
      moduleId: 7
  },

  // {
  //   url: "/QuickOpDashboard",
  //   name: "Quick Op",
  //   slug: "QuickOp",
  //   icon: "ClipboardIcon",
  // },
  // {
  //   url: "/IpDashboardView",
  //   name: "IP Dashboard",
  //   slug: "ipDashboard",
  //   icon: "ClipboardIcon",
  // },
  {
    url: null,
    name: "Reports",
    slug: "Reports",
    icon: "BookIcon",
    submenu: [
      {
        url: '/billReports',
        name: "Bill Reports",
        slug: "billReports",
          moduleId: 10
       
      },
      {
        url: '/tokenReports',
        name: "Token Reports",
        slug: "tokenReports",
          moduleId: 11
      },
      {
        url: '/OpReports',
        name: "OP Reports",
        slug: "opReports",
          moduleId: 11
      },
       {
        url: '/TokenShiftReport',
        name: "TokenShiftReport",
        slug: "opReports",
          moduleId: 13
      },
    ]
  },

  {
    url: null,
    name: "Settings",
    slug: "page2",
    icon: "SettingsIcon",
    submenu: [
      {
        url: '/doctorAppointmentConfig',
        name: "Appointment Config",
        slug: "AppointmentConfig",
          moduleId: 8
       
      },
      {
        url: '/doctorAppointmentSchedule',
        name: "Appointment Scheduler",
        slug: "ApointmentSchedule",
          moduleId: 9
       
      },
       {
        url: '/Master',
        name: "Master",
        slug: "Common Master",
          moduleId: 12
       
      },
     /* {
        url: '/billMaster',
        name: "Bill Master",
        slug: "billMaster",
       
      },
      {
        url: '/doctorMaster',
        name: "Doctor Master",
        slug: "doctorMaster",
      }*/
      // {
      //   url: '/roomCategory',
      //   name: "Room Category",
      //   slug: "roomCategory",
      // },
      // {
      //   url: '/roomMaster',
      //   name: "Room Master",
      //   slug: "roomMaster",
      // },
      // {
      //   url: '/roomRateEntry',
      //   name: "Room Rate Entry",
      //   slug: "roomRateEntry",
      // },
    ]
  },
  // {
  //   url: null,
  //   name: "Reports",
  //   slug: "Reports",
  //   icon: "BookIcon",
  //   submenu: [
  //     {
  //       url: '/billReports',
  //       name: "Bill Reports",
  //       slug: "billReports",
       
  //     },
  //     {
  //       url: '/tokenReports',
  //       name: "Token Reports",
  //       slug: "tokenReports",
  //     },
  //   ]
  // }
]
